var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrrickLogoWordmark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 577,
    height: 325,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M.83 122.837c12.678 10.319 28.633 16.13 45.433 16.13 5.672 0 11.532-.74 17.421-2.198 32.195-8.006 54.684-36.754 54.684-69.912 0-30.789-25.05-55.842-55.847-55.842-11.897 0-23.156 3.649-32.48 10.314 8.932-9.474 20.618-16.226 33.6-19.185C68.64 1.008 73.62.429 78.441.429c36.627 0 66.428 29.799 66.428 66.428 0 45.718-37.186 82.91-82.896 82.91-23.646 0-45.649-9.962-61.142-26.93"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: "50%",
    x2: "50%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#AECA95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "30%",
    stopColor: "#9EBD81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "70%",
    stopColor: "#749B52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#658043"
  })), /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "M.413 84.761c.035-.182.059-.374.059-.568 0-.192-.024-.385-.059-.566C.716 38.21 37.864 1.289 83.307 1.289c23.158 0 44.993 9.739 60.497 26.28-12.43-9.677-27.82-15.138-43.767-15.138-5.4 0-10.865.622-16.249 1.848-30.72 7.001-53.019 32.825-55.483 64.249-.134 1.655-.276 3.59-.281 5.583.005 2.153.147 4.097.281 5.78a55.68 55.68 0 0 0 55.554 50.15c12.012 0 23.653-3.956 33.172-10.978a66.939 66.939 0 0 1-33.295 19.857c-5.452 1.364-10.881 2.053-16.136 2.053-36.779 0-66.881-29.69-67.187-66.212"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: "0%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#749B52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "70%",
    stopColor: "#475632"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#475632"
  })), /*#__PURE__*/React.createElement("path", {
    id: "g",
    d: "M0 480h672V0H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(1 0 0 -1 -47 402)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(478.667 252)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "url(#b)",
    fillRule: "nonzero",
    mask: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.83 122.837c12.678 10.319 28.633 16.13 45.433 16.13 5.672 0 11.532-.74 17.421-2.198 32.195-8.006 54.684-36.754 54.684-69.912 0-30.789-25.05-55.842-55.847-55.842-11.897 0-23.156 3.649-32.48 10.314 8.932-9.474 20.618-16.226 33.6-19.185C68.64 1.008 73.62.429 78.441.429c36.627 0 66.428 29.799 66.428 66.428 0 45.718-37.186 82.91-82.896 82.91-23.646 0-45.649-9.962-61.142-26.93"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(457.333 234.667)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "url(#e)",
    fillRule: "nonzero",
    mask: "url(#f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.413 84.761c.035-.182.059-.374.059-.568 0-.192-.024-.385-.059-.566C.716 38.21 37.864 1.289 83.307 1.289c23.158 0 44.993 9.739 60.497 26.28-12.43-9.677-27.82-15.138-43.767-15.138-5.4 0-10.865.622-16.249 1.848-30.72 7.001-53.019 32.825-55.483 64.249-.134 1.655-.276 3.59-.281 5.583.005 2.153.147 4.097.281 5.78a55.68 55.68 0 0 0 55.554 50.15c12.012 0 23.653-3.956 33.172-10.978a66.939 66.939 0 0 1-33.295 19.857c-5.452 1.364-10.881 2.053-16.136 2.053-36.779 0-66.881-29.69-67.187-66.212"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#2C3B45",
    fillRule: "nonzero",
    mask: "url(#h)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M309.374 80.481h14.672v102.383h-14.672zM101.529 185.827c-29.82 0-53.994-24.177-53.994-53.995 0-29.824 24.174-53.997 53.994-53.997 29.818 0 53.992 24.173 53.992 53.997 0 29.818-24.174 53.995-53.992 53.995m0-95.156c-22.734 0-41.159 18.43-41.159 41.161 0 22.73 18.425 41.159 41.159 41.159 22.732 0 41.161-18.43 41.161-41.159 0-22.732-18.43-41.161-41.161-41.161m328.648 14.277c-7.531-8.625-18.582-14.107-30.931-14.107-22.69 0-41.087 18.4-41.087 41.086.004 22.694 18.397 41.09 41.087 41.09 12.478 0 23.629-5.584 31.164-14.366l10.113 7.905c-9.887 11.772-24.697 19.27-41.277 19.27-29.764 0-53.899-24.13-53.899-53.9 0-29.763 24.135-53.893 53.899-53.893 16.442 0 31.15 7.391 41.037 19.008l-10.107 7.907z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.75 234.215V80.295h11.696l2.969 4.384v.02l26.826 39.437 29.298-43.743h17.867l-38.001 57.21 30.894 45.416h-17.634l-49.25-74.859v126.055z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.734 167.958c7.426 11.013 21.972 17.224 36.425 17.224v-12.841c-20.1 0-36.425-16.298-36.425-36.391V80.467h-14.667v102.396h14.667v-14.905zm-68.32 0c7.426 11.013 21.972 17.224 36.425 17.224v-12.841c-20.1 0-36.425-16.298-36.425-36.391V80.467h-14.667v102.396h14.667v-14.905z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrrickLogoWordmark);
export default __webpack_public_path__ + "static/media/orrick-logo-wordmark.c05d24f125541c09f8eed6bd90a4c587.svg";
export { ForwardRef as ReactComponent };